export const REDIRECT_TO_LOGIN = "/auth/login-page";
